module.exports = __webpack_public_path__ + "a175a3518e36876450ab72ff2988ec8c.svg";